<template>
  <f7-page name="product">
    <f7-navbar :title="product.title" back-link="Back"></f7-navbar>
    <f7-block-title>About {{product.menu_name}}</f7-block-title>
    <f7-block strong>
      {{product.food_pic}}
      <img v-bind:src="foodUrl+product.food_pic" width="100%"  />
      {{product.menu_desc}}
    </f7-block>
  </f7-page>
</template>
<script>
  export default {
    data: function () {
 
      var menuId = this.$f7route.params.menuid;
      var productId = this.$f7route.params.itemid;
      var sel_item=this.$f7route.context.selected_menu;
     // var sel_item=menudata.MenuList[menuId].productId;
      /*this.$f7.data.products.forEach(function (product) {
        if (product.id === productId) {
          currentProduct = product;
        }
      });*/

      return {
        product: sel_item,
      foodUrl:"https://www.foodfile.co.kr/app/imagefile.php?wsize=970&r=2&img=",
      };
    }
  };
</script>
